export default {
    namespaced: true,

    state: {
        counter: 0,
    },
    mutations: {
        increase(state) {
            state.counter++;
        },
        decrease(state) {
            state.counter = state.counter > 0 ? state.counter - 1 : 0;
        },
        reset(state) {
            state.counter = 0;
        },
    },
    getters: {
        counter: state => state.counter,
    },
};
